const whatsappUrl = 'https://wa.me/905077089198?text=Merhaba%2C%20V%C4%B0AYP%C4%B0%C4%B0%20Temizlik%20i%C3%A7in%20teklif%20almak%20istiyorum.%20Temizlenecek%20alan%C4%B1n%20videosunu%20g%C3%B6ndermek%20istiyorum.';

export default function Hero() {
  return (
    <section id="ana-sayfa" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/d4ea5fe3d65b00a3422d1dea57329527.png"
          alt="VİAYPİİ Temizlik profesyonel ekip lüks rezidans temizliği"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-dark/80 via-navy-dark/60 to-navy-dark/80"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20 pb-16">
        <p className="text-gold text-xs md:text-sm font-semibold tracking-[0.2em] uppercase mb-4 md:mb-6">
          Profesyonel Temizlik Hizmetleri
        </p>

        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4 md:mb-6">
          <span className="block">SAAT HESABI DEĞİL.</span>
          <span className="block text-gold">İŞİN TAMAMI.</span>
        </h1>

        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
          Eviniz, villanız, residence daireniz veya iş yeriniz için temizlenecek alanı önce değerlendiriyor;
          yapılacak işe uygun ekip, ekipman ve çalışma planını oluşturuyoruz.
        </p>

        <p className="text-gold-light text-base md:text-lg font-medium mb-8 md:mb-10 max-w-xl mx-auto">
          Alanınızın kısa videosunu gönderin, size özel teklifimizi hazırlayalım.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-gold hover:bg-gold-dark text-navy-dark font-bold text-base md:text-lg rounded-md transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            WhatsApp'tan Video Gönder
          </a>
          <a
            href="#hizmetlerimiz"
            className="inline-flex items-center gap-2 px-8 py-4 border border-white/30 text-white hover:bg-white/10 font-semibold text-base rounded-md transition-all duration-300 whitespace-nowrap"
          >
            Hizmetleri İncele
            <i className="ri-arrow-down-line"></i>
          </a>
        </div>

        <p className="text-white/60 text-xs md:text-sm flex items-center justify-center gap-2 flex-wrap">
          <span className="flex items-center gap-1"><i className="ri-check-line text-gold"></i> Profesyonel Ekip</span>
          <span className="hidden sm:inline text-white/30">•</span>
          <span className="flex items-center gap-1"><i className="ri-check-line text-gold"></i> Profesyonel Ekipman</span>
          <span className="hidden sm:inline text-white/30">•</span>
          <span className="flex items-center gap-1"><i className="ri-check-line text-gold"></i> Malzemeli Hizmet</span>
        </p>
      </div>
    </section>
  );
}